import { usePresentationContext } from '@mentimeter/question-modules-contexts';
import {
  getNinePointLayoutProperties,
  TitleSection,
} from '@mentimeter/question-modules-shared';
import React from 'react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { VideoDataHandler } from './components/VideoDataHandler';

export function VideoPresentation() {
  const { useQuestion, useConfig } = usePresentationContext();

  const {
    layout,
    question,
    title_meta,
    question_video_embed_url,
    question_styled,
  } = useQuestion();
  const { enableAnimations, readonly, mode } = useConfig();
  const { textAlign, justifyContent, alignItems } =
    getNinePointLayoutProperties(layout);

  return (
    <Box
      width="100%"
      height="100%"
      data-testid="video-container"
      justifyContent={justifyContent}
      alignItems={alignItems}
    >
      <VideoDataHandler
        videoUrl={question_video_embed_url}
        shouldShowPreview={mode === 'screenshot'}
        readonly={readonly}
      />
      <TitleSection
        enablePlaceholderAlignment
        enableAnimations={enableAnimations}
        alignItems={alignItems}
        textAlign={textAlign}
        question={question}
        questionStyled={question_styled}
        title_meta={title_meta}
        layout={layout}
        mb="space0"
        placeholder="Add your caption here..."
        showTextSizeDropdown={false}
      />
    </Box>
  );
}
